import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ApiResource } from '../../resources/api.resource';
import { ApiService } from 'src/app/services/api.service';

declare var $: any;

@Component({
  selector: 'documentos-onbase-component',
  templateUrl: './documentos-onbase.component.html',
  styleUrls: ['./documentos-onbase.component.scss']
})
export class DocumentosOnbaseComponent implements OnInit {
  @Input('configuration') configuration;

  


constructor(private router: Router, private resource: ApiResource, private globals: ApiService) {

  }


  //  //listar productos contradados
  public Productos: string[] =
    [
      'Crédito de Consumo',
      'Crédito Hipotecario',
      'Cuenta de Ahorro',
      'Cuenta Corriente',
      'Banca Electrónica',
      'Contrato de Tarjeta de Crédito'
    ];

  public form_data = {
    dui: '',
    telefono: '',
    correo: '',
    tipoCorreo:'3',
    tipoSolicitud:'3'
    
  };

   public form_data_error = {
    //Error: 'Ha ocurrido un error de conexión en el intento de consulta de contrato para el NIU: ',
    DUI: '',
    Telefono:'',
    tipoCorreo:'5',
    tipoSolicitud:'5'
    
  };
  
  public tipoProdV: string;
  public refProductoV: string;
  public duiV: string;
  public telefonoV: string;
  public correoV: string;

  public form_solic_prod = {
    Tipo_Producto: '',
    Referencia_Producto: '',
    DUI: '',
    Telefono: '',
    Correo: '',
    tipoCorreo:'6',
    tipoSolicitud:'6'
  }



public indiceTipo;

  public validacionToken = {
    dui: null,
    token: null
  };

 

  public lista;
  listaDocumentosOnbase: any[] = [];

  public mensajeParaValidacionToken = '';

  public activarBotonDeModal = true;

  

  
    enviarCorreoElectronicoError() {

      
  
    //se llenan las variables del areglo con las variables de form_data de la primer modal solicitada de datos
    console.log('send mail error');

    this.form_data_error.DUI=this.duiV;
    this.form_data_error.Telefono=this.telefonoV;
    console.log('DUI: '+this.duiV);
    console.log('telefonoV: '+this.telefonoV);

    let data = {
      form_data: this.form_data_error,
      to:'',// 'fatima.mejia@davivienda.com.sv,diego.pineda@davivienda.com.sv  ',
      //to: this.configuration.contratos_email,
      form_name: "Error en consulta digital de contratos"
    };

    this.resource.sendEmail(data).subscribe(resp => {
      if (resp.response == 'Success.') {
        this.form_data_error.DUI=null;
        this.form_data_error.Telefono=null;
      }
      else {
        this.form_data_error.DUI=null;
        this.form_data_error.Telefono=null;
      }
    },
      err => {
        this.form_data_error.DUI=null;
        this.form_data_error.Telefono=null;

      }
    );
  }
  
  
  
  
  enviarCorreoElectronico() {
    //se llenan las variables del areglo con las variables de form_data de la primer modal solicitada de datos
    
    console.log('send mail prod');
    this.tipoProdV = this.form_solic_prod.Tipo_Producto;
    this.refProductoV = this.form_solic_prod.Referencia_Producto;

    this.form_solic_prod = {
      Tipo_Producto: this.tipoProdV.toString(),
      Referencia_Producto: this.refProductoV.toString(),
      DUI: this.duiV.toString(),
      Telefono: this.telefonoV.toString(),
      Correo: this.correoV.toString(),
      tipoCorreo:'6',
    tipoSolicitud:'6'
    };

    let data = {
      form_data: this.form_solic_prod,
      to:'', //'fatima.mejia@davivienda.com.sv,diego.pineda@davivienda.com.sv  ',
     //to: this.configuration.contratos_email,
      form_name: "Consulta fallida de contrato digital por falta de documentos"
    };

    this.resource.sendEmail(data).subscribe(resp => {
      if (resp.response == 'Success.') {
        this.form_solic_prod.Correo = null;
        this.form_solic_prod.DUI = null;
        this.form_solic_prod.Telefono = null;
        this.form_solic_prod.Referencia_Producto = null;
        this.form_solic_prod.Tipo_Producto = null;

      }
      else {
        this.form_solic_prod.Correo = null;
        this.form_solic_prod.DUI = null;
        this.form_solic_prod.Telefono = null;
        this.form_solic_prod.Referencia_Producto = null;
        this.form_solic_prod.Tipo_Producto = null;
      }
    },
      err => {
        this.form_solic_prod.Correo = null;
        this.form_solic_prod.DUI = null;
        this.form_solic_prod.Telefono = null;
        this.form_solic_prod.Referencia_Producto = null;
        this.form_solic_prod.Tipo_Producto = null;

      }
    );
  }

  ngOnInit() {
    this.toggleModal();
    console.log('conf: '+this.configuration);
    
  }

  toggleModal(isLast = false) {
    let modalForm = $('#documentos');

    if (modalForm.hasClass('active')) {
      $('body').removeClass('overflow-hidden');
    } else {
      $('body').addClass('overflow-hidden');
    }

    modalForm.toggleClass('active');

    if (isLast) {
      this.showModal(1);
    }
  }

  tokenVencido = false;

  reintentar() {
    this.mensajeParaValidacionToken = "";
    $('.page-modal .modal').removeClass('active');
    $('.page-modal .modal-1').addClass('active');
  }

  showModal(id) {

//console.log('cmail: '+this.configuration.contratos_email);
    this.activarBotonDeModal = false;
    this.tokenVencido = false;

    // generar token
    if (id == 2) { // tel, dui, email

      console.log(this.configuration);
      this.resource.getNIU(this.form_data).subscribe(resp => {

        this.validacionToken.token = "";
        this.validacionToken.dui = "";

        if (resp.estado == 'success') {
          // this.validacionToken.token = resp.token;
          this.validacionToken.dui = this.form_data.dui;
          // this.enviarCorreoElectronico();
          //llenar variables para el envio de datos en modal 5
          this.duiV = this.form_data.dui;
          this.telefonoV = this.form_data.telefono;
          this.correoV = this.form_data.correo;

          $('.page-modal .modal').removeClass('active');
          $('.page-modal .modal-' + id).addClass('active');
          this.activarBotonDeModal = true;
        }
        else {
          $('.page-modal .modal').removeClass('active');
          $('.page-modal .modal-4').addClass('active');
          this.activarBotonDeModal = true;
        }
      }, err => {
        $('.page-modal .modal').removeClass('active');
        $('.page-modal .modal-4').addClass('active');
        this.activarBotonDeModal = true;
      });
    }


    if (id == 7) { // tel, dui, email

      console.log(this.configuration);
          this.enviarCorreoElectronico()
          $('.page-modal .modal').removeClass('active');
          $('.page-modal .modal-7').addClass('active');
          this.activarBotonDeModal = true;
       
    }
    //validar token
    if (id == 3) { //token

      this.mensajeParaValidacionToken = '';
      this.activarBotonDeModal = false;
      this.resource.validateToken(this.validacionToken).subscribe(resp => {
        if (resp.estado == 'tokenSuccess') {
          this.obtenerDocumentosOnbase(this.validacionToken.dui, this.validacionToken.token, id);

        }
        else if (resp.estado == 'tokenVencido') {
          this.mensajeParaValidacionToken = 'Token vencido, por favor intenta nuevamente...';
          this.tokenVencido = true;
          this.activarBotonDeModal = true;
        }
        else if (resp.estado == 'not found') {
          this.mensajeParaValidacionToken = 'Token no valido...';
          this.activarBotonDeModal = true;
        }

        else {
          $('.page-modal .modal').removeClass('active');
          $('.page-modal .modal-4').addClass('active');
          this.activarBotonDeModal = true;
        }
      }
        , err => {
          $('.page-modal .modal').removeClass('active');
          $('.page-modal .modal-4').addClass('active');
          this.activarBotonDeModal = true;

        }
      );
    }



    
  }
//metodo para determinar si existe el documento
  public indice(array:any[],tipo){
   this.indiceTipo = array.findIndex(x => x.tipoProducto === tipo);
   if(this.indiceTipo!=-1){
     console.log('true indice');
     return true;
   }
  console.log('false indice');

   return false;
  }


public mostrarMiniForm(){
    $('.page-modal .modal').removeClass('active');
        //5 tiene que ser
        $('.page-modal .modal-6').addClass('active');
        this.activarBotonDeModal = true;
}

public solicitudEnviada(){
  $('.page-modal .modal').removeClass('active');
        //5 tiene que ser
        $('.page-modal .modal-7').addClass('active');
        this.activarBotonDeModal = true;
}

  public obtenerDocumentosOnbase(dui: string, token: string, id) {
    this.activarBotonDeModal = false;

    let body = {
      "codLlaveOnbase": "1",
      "valorLlaveOnbase": dui,
      "tipoDocumento": "1",
      "tipoRutaArchivos": "2",
      "token": token
    };
    //this.validacionToken
    this.resource.documentosOnbase(body).subscribe(resp => {

      this.lista = resp;
      this.listaDocumentosOnbase = resp.data;
      // not found
      if (this.lista.codigo == 0) {
        $('.page-modal .modal').removeClass('active');
        $('.page-modal .modal-3').addClass('active');
        this.activarBotonDeModal = true;
      }
      // not found
      if (this.lista.codigo == 1) {
        $('.page-modal .modal').removeClass('active');
        $('.page-modal .modal-4').addClass('active');
        this.activarBotonDeModal = true;
      }
      // falla OnBAse y fabrica
      if (this.lista.codigo == 2 || this.lista.codigo == 3 || this.lista.codigo == 999) {
        this.enviarCorreoElectronicoError();

        $('.page-modal .modal').removeClass('active');

        //5 tiene que ser
        $('.page-modal .modal-5').addClass('active');
        this.activarBotonDeModal = true;

      }
      // el cliente no posee documentos activos
      if (this.lista.codigo == 4 || this.lista.codigo == 5) {
        $('.page-modal .modal').removeClass('active');
        $('.page-modal .modal-6').addClass('active');
        this.activarBotonDeModal = true;
      }
    }
      , err => {
        $('.page-modal .modal').removeClass('active');
        $('.page-modal .modal-4').addClass('active');
        this.activarBotonDeModal = true;
      }
    );
  }

  nuevoMetodo() {
    //this.listaDocumentosOnbase.sort(function(a, b) { var dateA = new Date(a.fechaDocumento), dateB = new Date(b.fechaDocumento); return dateA - dateB; });
  }

  cerrarModal() {
    // remuevo las clases
    $('.page-modal .modal').removeClass('active');
    $('.page-modal .modal-1').addClass('active');

    this.form_data = {
      dui: '',
      telefono: '',
      correo: '',
      tipoCorreo:'3',
      tipoSolicitud:'3'
      
    };
    this.listaDocumentosOnbase = [];
  }


  urlServiceDescargarOnbase = `${this.globals.urlServidor}/descargar/`;

  descargar(nameFile: any) {
    // window.open(this.urlServiceDescargarOnbase + nameFile, '_self');//Original
    window.open(this.urlServiceDescargarOnbase + nameFile, '_blank');
  }

  onlyNumbers(event) {
    let keyCode = event['keyCode'] || 0;
    if (keyCode < 48 || keyCode > 57) {
      event.preventDefault();
    }
  }



}
